import { useState, useEffect, useContext, useRef } from "react";
import thumbnailsData from "../../data/thumbnails";
import avatar1 from "../../assets/images/avatar1.png";
import list from "../../data/thumbnails";

const Search = () => {
  const [data, setData] = useState(list);
  const useImageLoaded = () => {
    const [loaded, setLoaded] = useState(false);
    const ref = useRef();
    const onLoad = (index) => {
      if (index === data.length - 1) {
        setTimeout(() => {
          setLoaded(true);
        }, 2000);
      }
    };

    useEffect(() => {
      if (ref.current && ref.current.complete) {
        onLoad();
      }
    });

    return [ref, loaded, onLoad];
  };

  const [ref, loaded, onLoad] = useImageLoaded();

  return (
    <div className="w-100p" id="search-results-page">
      <div className="space-between m-l-15">
        <span>
          Found 50 Courese for <strong>"Firefox"</strong>
        </span>
        <div className="a">sort</div>
      </div>
      <div>
        {!loaded && (
          <div className="create-meeting-thumbnails">
            {Array.from(Array(16), (e, i) => {
              return (
                <div className="create-meeting-thumbnail img-preview">
                  <div className="img-preview"> loading... </div>
                </div>
              );
            })}
          </div>
        )}

        {data.map((i, index) => {
          return (
            <div className={`create-meeting-thumbnail ${!loaded && `visibility-hidden`}`}>
              <div className="meeting-thumbnail-info">
                <div className="space-between p-10 h-56">
                  <>
                    <div className="meeting-thumbnail-detail">
                      <span className="meeting-thumbnail-duration">{i.duration}</span>
                      <span className="meeting-thumbnail-screens">
                        <span>{i.screens}</span>
                      </span>
                      <span className="meeting-thumbnail-steps">
                        <span>{i.steps}</span>
                      </span>
                    </div>
                  </>
                </div>
              </div>
              <img src={i.imgPath} ref={ref} onLoad={() => onLoad(i.id)} key={index} className="absolute z-index-01" />
              <div className="meeting-thumbnail-more-info">
                <strong>{i.description}</strong>
                <div className="align-items-center p-tb-10">
                  <img src={avatar1} width={30} className="m-r-5" />
                  <div className="w-50 bold"> Lisa </div>
                  <div className="flex">
                    <span className="w-16 flex-end">2</span>k view - 2 months age
                  </div>
                </div>
                <div>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum eos placeat odio ad nulla voluptas impedit voluptatibus odit. Dolorum
                  vero sapiente nam! Corrupti earum fugit nulla dolorum, sapiente tenetur! Nulla porro sit quas delectus corrupti qui! Sunt, labore
                  sit? Accusantium molestiae dolores quae quas nihil inventore optio totam quibusdam nostrum!
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Search;
